import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=278ee5fd&scoped=true"
import script from "./ProductActions.vue?vue&type=script&lang=ts"
export * from "./ProductActions.vue?vue&type=script&lang=ts"
import style0 from "./ProductActions.vue?vue&type=style&index=0&id=278ee5fd&prod&lang=scss&scoped=true"
import style1 from "./ProductActions.vue?vue&type=style&index=1&id=278ee5fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278ee5fd",
  null
  
)

export default component.exports